export const countPropsWithPrefix = (obj, prefix) => {
    if (typeof obj !== 'object' || obj === null) return 0;
    return Object.keys(obj).filter(key => key.startsWith(prefix)).length;
}
